import { gql } from 'graphql-request'

const GET_SEARCH_FILTERS = gql`
  query getFilters($search: String) {
    type: products(
      where: {
        status: { _eq: "active" }
        _or: [
          { name: { _ilike: $search } }
          { creator: { nickname: { _ilike: $search } } }
        ]
      }
      distinct_on: type
    ) {
      id: type
      name: type
    }
    product_categories(
      where: {
        products: {
          product: {
            status: { _eq: "active" }
            _or: [
              { name: { _ilike: $search } }
              { creator: { nickname: { _ilike: $search } } }
            ]
          }
        }
      }
    ) {
      id
      name
    }
    creator_categories(
      where: {
        creators: {
          account_status: { _eq: "active" }
          _or: [
            {
              products: { status: { _eq: "active" }, name: { _ilike: $search } }
            }
            { nickname: { _ilike: $search } }
          ]
        }
      }
    ) {
      id
      name
    }
    # collections: fansi_collection_groups(
    #   where: {
    #     creator: { account_status: { _eq: "active" } }
    #     products: {
    #       status: { _eq: "active" }
    #       _or: [
    #         { name: { _ilike: $search } }
    #         { creator: { nickname: { _ilike: $search } } }
    #       ]
    #     }
    #   }
    # ) {
    #   id
    #   name
    # }
  }
`
export default GET_SEARCH_FILTERS
